import { Loader2 } from "lucide-react";
import { cx } from "../cx.ts";

/** An inline loading indicator with a text alternative. */
export function Spinner({ label = "Loading", className }: { label?: string; className?: string }) {
  return (
    <span
      role="status"
      className={cx("inline-flex items-center gap-2 text-ink-muted text-sm", className)}
    >
      <Loader2 aria-hidden className="size-4 animate-spin" />
      <span>{label}</span>
    </span>
  );
}
